import React, {useState, useEffect} from 'react';
import Intro from '../Components/Intro'
import Nav from '../Components/nav'
import Intro2 from '../Components/Intro2'
import Aboutme from '../Components/aboutme'
import SideBar from '../Components/sideBar';
import Projects from '../Components/project';
import Gmail from '../Components/mail';
import {makeStyles} from '@material-ui/core/styles';
import { Hidden } from '@material-ui/core';
import Loading from '../Components/loading';
import Footer from '../Components/footer';

const useStyles=makeStyles((themes)=>({

    sidebar:{
        left:"0",
        backgroundColor:"rgba(22,33,90,255)",
        top:"40%",
        position:"fixed",
        borderTopRightRadius:"10px",
        borderBottomRightRadius:"10px",

        [themes.breakpoints.down('xs')]: {
            backgroundColor:"rgba(22,33,90,255)",
          },

 
    }
    }));

export default function Land1(){

const classes =useStyles()


const [loading, setLoading] = useState(false);

useEffect(()=>{

    setLoading(true)
    setTimeout(()=>{
        setLoading(false)
    }, 4200)
},[])
    
    return(
        <div>

            {
                loading ?

                <Loading></Loading>
                :
                <div>
                <Nav></Nav>
        

                <Intro></Intro>
                <Intro2></Intro2>
                <Aboutme></Aboutme>
                <Projects></Projects>
                <Gmail></Gmail>
                <Footer></Footer>

            <Hidden >
            <div className={classes.sidebar}>
                <SideBar></SideBar>
            </div>
            </Hidden>
            </div>
            }



        </div>

    )
}